<template>
  <v-container class="A4 mb-3" id="printMe">
     
    <v-row class="d-flex justify-end my-header">
      <v-btn @click="goBack" class="primary my-btn my-1">
        <i class="mdi mdi-arrow-left-bold"></i>返回
      </v-btn>
     
      <v-btn @click="confirm" class="primary my-btn  ml-1 my-1">
        <i class="mdi mdi-card-account-details"></i>保存
      </v-btn>
      <v-btn @click="readIdCard" class="primary my-btn  ml-1 my-1">
        <i class="mdi mdi-card-account-details"></i>读取乙方身份证
      </v-btn>
       <v-btn @click="readIdCardEntrust" class="primary my-btn  ml-1 my-1">
        <i class="mdi mdi-card-account-details"></i>读取委托人身份证
      </v-btn>
       <v-btn v-print="printObj" class="primary my-btn my-1 ml-1 mr-11">
        <i class="mdi mdi-printer"></i>打印
      </v-btn>
    </v-row>

    <h1 class="head-1" style="width:50%;text-align:center;">
      嘉善县城中村改造安置买卖合同
    </h1>
<v-row style="width:50%;display: inline-flex;border-right: 0.5px solid #555555;margin-left:-5px !important;">
    
    <v-row class="note-header">
      <span style="font-weight:600;width:500px" >合同双方当事人：</span>
        <!-- <input type="text" name="name" class="my-input260" v-model="agreement.party" styler="display:none" /> -->
    </v-row>
    <v-row class="note-header">
      <span style="font-weight:600">出卖人：</span>
      <input type="text" name="name" class="my-input260" v-model="agreement.company" />（以下简称甲方）
    </v-row>
    <v-row class="note-header indent">
       <span>统一社会信用代码：<input type="text" name="name" class="my-input150" v-model="agreement.company_code" /></span>
       <span style="text-indent:1em">  资质证书号: (2016)善房47号</span>
    </v-row>
    <v-row class="note-header ">
       <span class="indent">法人代表：<input type="text" name="name" class="my-input65" v-model="agreement.company_user" /></span>
             <span style="text-indent:1em">  联系电话：<input type="text" name="name" class="my-input120" v-model="agreement.company_mobile"/></span>
             <span style="text-indent:1em"> 邮编：314100  </span>
      
    </v-row>
    <v-row class="note-header indent">
       <span>地址：<input type="text" name="name" class="my-input380" v-model="agreement.company_address"/></span>
    </v-row>
    <v-row class="note-header">
      <span ><span style="font-weight:600">买受人：</span>
        <input type="text" name="name" class="my-input260" v-model="customer_name1" @input = "customerChange()"/>，<input type="text" name="name" class="my-input260" v-model="customer_name2" @input = "customerChange()"/>
      </span>
      <span style="padding-left: 50px;">
        <input type="text" name="name" class="my-input260" v-model="customer_name3" @input = "customerChange()"/>，<input type="text" name="name" class="my-input260" v-model="customer_name4" @input = "customerChange()"/>
      </span>
      <span style="padding-left: 50px;">
        <input type="text" name="name" class="my-input260" v-model="customer_name5" @input = "customerChange()"/>
      </span>
      <span>
        （以下简称乙方）
      </span>
    </v-row>
    <!-- <v-row class="note-header indent">
       <span>身份证号：<input name="name" class="my-input405"  v-model="agreement.customer_idcard" >
             
      </span>
    </v-row>
    <v-row class="note-header indent" v-show="idcardstatus">
       <span><input name="name" class="my-input430" @change="setshow" v-model="agreement.customer_idcards">
             
      </span>
    </v-row> -->
      <!-- <v-row class="note-header">
       <span class="indent">地址：<input type="text" name="name" class="my-input300" value="" v-model="agreement.customer_address"/></span>
       <span style="text-indent:1em">电话：<input type="text" name="name" class="my-input120" value="" v-model="agreement.customer_mobile"/></span>
      </v-row> -->
      <v-row class="note-header ">
       <span class="indent">委托代理人：<input type="text" name="name" class="my-input260" value="" v-model="agreement.sub_name"/></span>
       <span style="text-indent:1em">联系电话：<input type="text" name="name" class="my-input120" value="" v-model="agreement.customer_mobile"/></span>
      </v-row>
      <!-- <v-row class="note-header indent">
       <span>联系电话：<input type="text" name="name" class="my-input200" value="" v-model="agreement.sub_mobile"/></span>
      </v-row> -->
      <v-row class="note-header indent line">
       <span>根据《中华人民共和国合同法》、《中华人民共和国城市房地产管理法》
《不动产登记暂行条例》、《不动产登记暂行条例实施细则》及其他有关法律、法规之规定，甲乙双方在平等、自愿、一致的基础上就买卖公寓安置房达成如下协议:</span>
      </v-row>
      <v-row class="note-header indent">
        <span><span style="font-weight:600">第一条：</span>乙方购买的拆迁安置房为现房。</span>
      </v-row>
      <v-row class="note-header indent line">
       <span><span style="font-weight:600">第二条：</span>乙方所购拆迁安置房的基本情况：
       </span>
       </v-row>
       <v-row class="note-header indent">
       <span>
       该不动产坐落于嘉善县<span class="data-text"> {{ details.garden_name }}{{ details.building_name }}幢{{
            details.unit_name
          }}单元{{ details.house_number }}室 </span>用途为住宅。
          </span>
       </v-row>
       <v-row class="note-header indent">
       <span>
       该房屋【合同约定】建筑面积共 <span class="data-text"> {{ details.area }} </span> 平方米，配套自行车库  <span> <input type="text" name="name" class="my-input35" v-model="agreement.sub_area" /> </span>  平方米、自行车位<span class="data-text"> 0 </span>个。
                </span>
      </v-row>
      <v-row class="note-header indent">
        <span ><span style="font-weight:600">第三条：</span>购房价款及付款方式
        </span>
      </v-row>
       <v-row class="note-header indent">
       <span>1、购房价款：住宅房款<span class="data-text"> {{ details.house_fee }} </span>元，自行车库<span> <input type="text" name="name" class="my-input55" v-model="agreement.sub_fee" @keyup="changeDig()" /></span>元，车位<span> <input type="text" name="name" class="my-input55" v-model="agreement.car_fee" @keyup="changeDig()"  /></span>元，
       总价人民币￥：<span class="data-text"> {{ details.total_house_fee }} </span>元，大写：<span class="data-text"> {{ details.total_house_fee_chinese }} </span> 。
       </span>
      </v-row>
      <v-row class="note-header indent">
       <span>2、付款方式：
       </span>
      </v-row>
      <v-row class="note-header indent">
       <span>乙方一次性付清购房款，应付人民币(￥：<span class="data-text"> {{ details.total_house_fee }} </span>  元)，代收费用计人民币(￥：<span class="data-text"> {{ (Number(details.repair_special_fee)+Number(details.sub_repair_fee)).toFixed(2) }} </span>元) ，应在房屋交付前付清。
       </span>
      </v-row>
      
      <v-row class="note-header indent">
        <span ><span style="font-weight:600">第四条：</span>面积确认及面积差异处理
        </span>
      </v-row>
      <v-row class="note-header indent line">
       <span>根据当事人选择的计价方式，本条规定以【建筑面积】【本条款式均简称面积】为依据进行面积确认及面积差异处理。</span>
      </v-row>
      <v-row class="note-header indent">
       <span>当事人选择按套计价的，不适用本条规定。</span>
      </v-row>
      <v-row class="note-header indent">
       <span>合同约定面积与不动产登记面积有差异的，以不动产登记面积为准。</span>
      </v-row>
      <v-row class="note-header indent">
       <span>拆迁安置房交付后，不动产登记面积与合同约定面积发生差异，甲乙双方同意按以下原则和方式进行处理：</span>
      </v-row>
     
      
    </v-row>
    <v-row  style="width:50%;display: inline-flex;margin-left:5px !important;margin-right:0px !important">
      <v-row class="note-header indent">
       <span>(1)面积误差比绝对值在3%以内 (含3%) 的，据实结算房价款。</span>
      </v-row>
      <v-row class="note-header indent">
       <span>(2)面积误差比绝对值超出3%时，乙方有权退房,</span>
      </v-row>
      <v-row class="note-header indent line">
       <span>(3)乙方退房的，甲方在乙方提出退房之日起30天内，将乙方已付款退还乙方，并按银行同期存款利率给付利息。</span>
      </v-row>
      <v-row class="note-header indent line">
       <span>(4)乙方不退房的，不动产登记面积大于合同约定面积时，面积误差比在3%以内(含3%)部分的房价款由乙方补足，超出3%部分的房价款由甲方承担，不动产归乙方。不动产登记面积小于合同约定面积时，面积误差比绝对值在3%以内(含3%)部分的房价款由甲方返还乙方；绝对值超出3%部分的房价款由甲方双倍返还乙方。</span>
      </v-row>
      <v-row class="note-header indent"  style="width:100%">
       <span  style="padding-left: 80px;">不动产登记面积--合同约定面积</span>
      </v-row>
      <v-row class="note-header indent"  style="width:100%">
       <span>面积误差比 = ------------------------------------------------- ×100%</span>
      </v-row>
      <v-row class="note-header indent" style="width:100%">
       <span  style="padding-left: 110px;">合同约定面积 </span>
      </v-row>
      <v-row class="note-header indent">
       <span>(5)因设计变更造成的面积差异，双方不解除合同的，应当签署补充协议。</span>
      </v-row>
      <v-row class="note-header indent line">
        <span ><span style="font-weight:600">第五条：</span>该不动产于付清房款后交付，乙方在接到交房通知15日内办理有关不动产移交手续，如需逾期，应补办续延手续。
        </span>
      </v-row>
      <v-row class="note-header indent line">
        <span ><span style="font-weight:600">第六条：</span>甲方提供的住房质量，需经嘉善县建筑工程质量监督站验收合格,甲方根据国家相关的法律法规进行房屋质量的保修，如由乙方人为造成的非房屋质量问题的房屋损坏，所产生的房屋维修费用由乙方承担。
        </span>
      </v-row>
      <v-row class="note-header indent line">
        <span ><span style="font-weight:600">第七条：</span>乙方对房屋装修时，应遵守中华人民共和国建设部令第110号《住宅室内装饰装修管理办法》和浙江省人民政府令第60号《浙江省城镇房屋装修管理办法》，不得擅自改变房屋结构，不得在小区内违章搭建及有违反城市规划的行为，不得在自用的自行车库、汽车库内开店、住人，在房屋外墙、窗、门安装防盗铁栅，并应遵守小区物业管理的其他规定，定期交纳小区物业管理费。
        </span>
      </v-row>
      <v-row class="note-header indent line">
        <span ><span style="font-weight:600">第八条：</span>本合同一式二份，甲、乙双方各执一份，签章后生效。
        </span>
      </v-row>
      
      <!-- <v-row class="note-header indent" style="width:100%">
       <span>（以下为正文，为签署页）</span>
      </v-row> -->
      <v-row class="note-header indent" style="width:100%;padding-top: 10px;">
       <span style="width:55%;">甲方（签章）： </span>
       <span style="width:45%;">乙方（签章）： </span>
      </v-row>
      <v-row class="note-header indent" style="width:100%;padding-top: 10px;">
       <span style="width:55%;">{{agreement.company}}</span>
       <span style="width:45%;"> </span>
      </v-row>
      <v-row class="note-header indent" style="width:100%;padding-top: 20px;">
       <span style="width:55%;">法定代表人：{{ agreement.company_user }} </span>
       <span style="width:45%;">委托代理人： </span>
      </v-row>
      <v-row class="note-header indent" style="width:100%">
       <span style="width:55%;">     </span>
       <span style="width:45%;">联系电话：{{ agreement.customer_mobile }}</span>
      </v-row>
      <v-row class="note-header indent" style="width:100%" >
       <span style="width:100%;text-align:right;">{{
          $moment(details.delivery_time).utc().format("YYYY年MM月DD日")}}</span>

      </v-row>
    </v-row>
    
    
<v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>
  </v-container>
  
  
</template>

<script>
import { fetchBill } from "@/api/bills";
import { fetchContract } from "@/api/contracts";
import { updateAgreements,fetchAgreement } from "@/api/agreement";
import { getReaderInfo,readIDCard } from "@/api/idcard";
import { convertCurrency } from '@/utils/chinese-money'
import request from '@/utils/request'

export default {
  name: "Bill Print",
  components: {},

  filters: {},
  data() {
    return {
      src: "hetong.png",
      seq: "",
      user_name: this.$store.getters.name,
      company: this.$store.getters.company,
      details: null,
      // population_price: 580,
      // property_price: 960,
      // extend20_price: 3510,
      // market_discount_price: 6110,
      // market_price: 6110,
      dt_now: "",
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "https://www.baidu.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      sub_fee:0,
      cssBackgroundImg: {
        backgroundImage: `url(${require("@/assets/background.jpg")})`
      },
      icons: {
        sub_bike: {
          status:false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        sub_car:{
          status:false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        bike: {
          status:false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        car:{
          status:false,
          icon: "mdi-checkbox-blank-circle-outline"
        }
      
      },
      httpUrl:"http://127.0.0.1:7846",
      wsUri :"ws://127.0.0.1:7846/ws",
      output:"",
      socket:"",
      msgid:0,
      websocket_supported:false,
      jsonp_supported:false,
      nameArray:"",
      idcardArray:"",
      idcardArray1:"",
      idcardstatus:false,
      snackbar: false,
      text: "",
      timeout: 3000,
      widthArray: [
        {
          // 5/18
          key: 0.28,
          value: "',.|:;I",
        },
        {
          // 6/18
          key: 0.34,
          value: 'ijl!(){}[]',
        },
        {
          // 7/18
          key: 0.39,
          value: 'frt ',
        },
        {
          // 8/18
          key: 0.45,
          value: 's_-"*',
        },
        {
          // 9/18
          key: 0.5,
          value: '1Jcvxyz/\\',
        },
 
        {
          // 10/18
          key: 0.56,
          value: 'ake?TL',
        },
        {
          // 11/18
          key: 0.62,
          value: '$ZF023456789',
        },
        {
          // 12/18
          key: 0.67,
          value: '#AVBYEKPSX',
        },
        {
          // 13/18
          key: 0.73,
          value: 'dbghnopquHDUCNR',
        },
        {
          // 14/18
          key: 0.78,
          value: 'w^<>=+~OQG',
        },
        {
          // 15/18
          key: 0.84,
          value: '&%M',
        },
        {
          // 17/18
          key: 0.95,
          value: 'mW',
        },
        {
          // 19/18
          key: 1.06,
          value: '@',
        },
      ],
      agreement:{
        party:"",
        company:"",
        company_code:"",
        company_user:"",
        company_mobile:"",
        company_address:"",
        customer:"",
        customer_idcard:"",
        customer_idcards:"",
        customer_address:"",
        customer_mobile:"",
        customer_array:"",
        sub_name:"",
        sub_idcard:"",
        sub_mobile:"",
        sub_area:"",
        sub_fee:"",
        car_num:"",
        car_fee:"",
        account_name:"",
        account_no:"",
        account_bank:"",
        contract_id:"",
      },
      customer_name1:"",
      customer_name2:"",
      customer_name3:"",
      customer_name4:"",
      customer_name5:"",
      is_entrust:false,
    }
  },

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("admin")) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getBill(this.$route.params.id);
    
    this.dt_now = Date.now();
    this.seq = this.$route.params.seq;
    this.readerInit()
  },

  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getBill(id) {
      this.listLoading = true;
      fetchContract(id).then(response => {
        this.details = response.data;
        this.customer_name1 = this.details.customer
        this.agreement.car_fee = "0.00";
        this.agreement.car_num = "/";
        this.details.total_house_fee_chinese = convertCurrency(this.details.total_house_fee)
        if (this.agreement.sub_area=="" && this.details.sub_area>0){
          this.agreement.sub_area = this.details.sub_area;
          this.agreement.sub_fee = this.details.sub_fee;
          this.icons.sub_bike.status=true
          this.icons.sub_bike.icon="mdi-checkbox-marked-circle-outline"
          this.icons.sub_car.status=false
          this.icons.sub_car.icon="mdi-checkbox-blank-circle-outline"
        }else{
          this.agreement.sub_area = "/"
          this.agreement.sub_fee = "/"
        }
        this.getAgreement(this.$route.params.id);
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    getAgreement(id) {
      this.listLoading = true;
      this.agreement.contract_id = id
      fetchAgreement(id).then(response => {
        if(response.data.code == 404){
          this.initData()
        }else{
          this.agreement = response.data;
          if (this.agreement.sub_area>0){
            this.icons.sub_bike.status=true
            this.icons.sub_bike.icon="mdi-checkbox-marked-circle-outline"
            this.icons.sub_car.status=false
            this.icons.sub_car.icon="mdi-checkbox-blank-circle-outline"
          }else{
            this.agreement.sub_area = "/"
            this.agreement.sub_fee = "/"
          }
          if (this.agreement.car_fee>0){
            this.icons.car.status=true
            this.icons.car.icon="mdi-checkbox-marked-circle-outline"
            this.icons.bike.status=false
            this.icons.bike.icon="mdi-checkbox-blank-circle-outline"
          }else{
            this.agreement.car_num = "/"
            this.agreement.car_fee = "/"
          }
          // this.initData()
          if (this.agreement.customer_array != ""){
            let arr = this.agreement.customer_array.split(",");
            console.log(arr);
            if(arr[0] != undefined){
              this.customer_name1=arr[0]
            }
            if(arr[1] != undefined){
              this.customer_name2=arr[1]
            }
            if(arr[2] != undefined){
              this.customer_name3=arr[2]
            }
            if(arr[3] != undefined){
              this.customer_name4=arr[3]
            }
            if(arr[4] != undefined){
              this.customer_name5=arr[4]
            }
          }
          this.changeDig()
        }
        
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    initData(){
      console.log(1212121)
      console.log(this.details)
      if(this.details.garden_name=="和善家园二期"){
        this.agreement.company = "嘉善善建旧城改造有限公司";
        this.agreement.company_user = '祝玲俐'
        this.agreement.company_code = "9133042174903777X8";
        this.agreement.company_mobile = "0573-84021863";
        this.agreement.company_address = "浙江省嘉善县大云镇创业路566号科创园二期1号楼11楼";
        this.agreement.account_name="嘉善善建旧城改造有限公司";
        this.agreement.account_no = "";
        this.agreement.account_bank = "";
      }

    },
    choice(id){
      if (id == 1 && this.icons.sub_car.status==false){
        this.icons.sub_car.status=true
        this.icons.sub_car.icon="mdi-checkbox-marked-circle-outline"
        this.icons.sub_bike.status=false
        this.icons.sub_bike.icon="mdi-checkbox-blank-circle-outline"
      }else if (id == 1 && this.icons.sub_car.status==true){
        this.icons.sub_car.status=false
        this.icons.sub_car.icon="mdi-checkbox-blank-circle-outline"
      }
      if (id == 2 && this.icons.sub_bike.status==false){
        this.icons.sub_bike.status=true
        this.icons.sub_bike.icon="mdi-checkbox-marked-circle-outline"
        this.icons.sub_car.status=false
        this.icons.sub_car.icon="mdi-checkbox-blank-circle-outline"
      }else if (id == 2 && this.icons.sub_bike.status==true){
        this.icons.sub_bike.status=false
        this.icons.sub_bike.icon="mdi-checkbox-blank-circle-outline"
      }
      if (id == 3 && this.icons.car.status==false){
        this.icons.car.status=true
        this.icons.car.icon="mdi-checkbox-marked-circle-outline"
        this.icons.bike.status=false
        this.icons.bike.icon="mdi-checkbox-blank-circle-outline"
      }else if (id == 3 && this.icons.car.status==true){
        this.icons.car.status=false
        this.icons.car.icon="mdi-checkbox-blank-circle-outline"
      }
      if (id == 4 && this.icons.bike.status==false){
        this.icons.bike.status=true
        this.icons.bike.icon="mdi-checkbox-marked-circle-outline"
        this.icons.car.status=false
        this.icons.car.icon="mdi-checkbox-blank-circle-outline"
      }else if (id == 4 && this.icons.bike.status==true){
        this.icons.bike.status=false
        this.icons.bike.icon="mdi-checkbox-blank-circle-outline"
      }
      
    },
    changeDig(){
     let sub_fee = 0
     let car_fee = 0
      if(this.agreement.car_fee >0){
        car_fee = this.agreement.car_fee
      }
      if(this.agreement.sub_fee >0){
        sub_fee = this.agreement.sub_fee
      }
      this.details.total_house_fee = (parseFloat(this.details.house_fee)+parseFloat(sub_fee)+parseFloat(car_fee)).toFixed(2)
      this.details.total_house_fee_chinese = convertCurrency(this.details.total_house_fee)
      this.details.total_fee = (parseFloat(this.details.total_house_fee)+parseFloat(
        this.details.repair_special_fee)).toFixed(2)
    },
    confirm() {
      const tempData = this.agreement;
      console.log(tempData);
      updateAgreements(tempData).then(response => {
        this.text = "数据保存成功";
        this.snackbar = true;
        
      });
      
    },
    activeWidth(item) {
      let strLength = 0;
      let characterNums = 0;
      if (item === '') {
        return 30 + 'rem';
      } else {
        let tempStr = item.split('');
        for (let i = 0; i < tempStr.length; i++) {
          // 判断字母数字特殊字符
          for (let j = 0; j < this.widthArray.length; j++) {
            if (this.widthArray[j].value.includes(tempStr[i]) === true) {
              strLength = this.widthArray[j].key  + strLength;
              characterNums = characterNums + 1;
            }
          }
        }
        strLength =
          strLength + (item.length - characterNums)  ;
        return strLength + 'rem';
      }
    },
    setshow(){
      if (this.idcardArray1 == ""){
        this.idcardstatus = false
      }
    },

    readerInit(wzxx) {
		
      if( this.websocket_supported == false || this.socket.readyState == 2 || this.socket.readyState == 3) {
        console.log(1231241)
        this.websocket_supported = this.wsOpen();
      }

      if( ! this.jsonp_supported) {
        getReaderInfo().then(response => {
          console.log(response);
          if(response.status == 200){
            this.jsonp_supported = true;
          }else{
            this.jsonp_supported = false;
          }
          
        });
      }
    },
    parseCardInfo(text) {
      var result = {};
      result['name'] = text.substr(0, 15).trim();
      result['gender'] = text.substr(15, 1).trim();
      result['race_id'] = text.substr(16, 2).trim();
      result['birthday'] = text.substr(18, 8).trim();
      result['address'] = text.substr(26, 35).trim();
      result['IDNumber'] = text.substr(61, 18).trim();
      result['issuer'] = text.substr(79, 15).trim();
      result['valied'] = text.substr(94, 8).trim();
      result['expire'] = text.substr(102, 8).trim();
      result['type'] = text.substr(124, 1).trim();

      if (result['type'] == 'J'){
        result['PassNumber'] = text.substr(110, 9);
        result['issueCount'] = text.substr(119, 2);
      }
      else if (result['type'] == 'I'){
        return false;
      }
      return result;
    },

    onWsOpen(evt) { 
    },
  
    onWsClose(evt) { 
    },

    onWsMessage(evt){ 
      var jsondata = JSON.parse(evt.data);
      
      // this.writeToScreen(evt.data); 

      if(jsondata.module == "idcard" && jsondata.function == "readcard" ) {
        
        if(jsondata.ret != 0) {
          //alert(jsondata.errorMsg);
          return ;
        }
        var	result = this.parseCardInfo(jsondata.data.text);
        console.log("获取身份证数据");
        console.log(this.is_entrust);
        if (this.is_entrust == true){
          this.agreement.sub_name = result.name+" "+result.IDNumber
          this.agreement.sub_idcard = result.IDNumber
        }else{
          if(this.agreement.customer == ""){
            this.agreement.customer_address = result.address
            this.agreement.customer = result.name
          }else{
            this.agreement.customer = this.agreement.customer+" "+result.name
          }
          if(this.agreement.customer_idcard == ""){
            this.agreement.customer_idcard = result.IDNumber
          }else if (this.agreement.customer_idcard.length>45){
            this.idcardstatus = true
            this.agreement.customer_idcards = this.agreement.customer_idcards+" "+result.IDNumber
          }else{
            this.agreement.customer_idcard = this.agreement.customer_idcard+" "+result.IDNumber
          }

          if (this.customer_name1 == ""){
            this.customer_name1 = result.name + " " + result.IDNumber
            this.agreement.customer_array = this.customer_name1
          }else if (this.customer_name2 == ""){
            this.customer_name2 = result.name + " " + result.IDNumber
            this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name2
          }else if (this.customer_name3 == ""){
            this.customer_name3 = result.name + " " + result.IDNumber
            this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name3
          }else if (this.customer_name4 == ""){
            this.customer_name4 = result.name + " " + result.IDNumber
            this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name4
          }else if (this.customer_name5 == ""){
            this.customer_name5 = result.name + " " + result.IDNumber
            this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name5
          }
        }
        
      }
      else if(jsondata.module == "idcard" && jsondata.function == "getsam" ) {
        if(jsondata.ret != 0) {
          //alert(jsondata.errorMsg);
          return ;
        }
      }
      else if(jsondata.module == "iccard" && jsondata.function == "getidsnr" ) {
        if(jsondata.ret != 0) {
          return ;
        }
      }
      else {
        return false
      }
    },
 
    customerChange(){
      console.log(4343434)
      this.agreement.customer_array  = ""
      if (this.customer_name1 != ""){
        this.agreement.customer_array = this.customer_name1
      }
      if (this.customer_name2 != ""){
        this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name2
      }
      if (this.customer_name3 != ""){
        this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name3
      }
      if (this.customer_name4 != ""){
        this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name4
      }
      if (this.customer_name5 != ""){
        this.agreement.customer_array = this.agreement.customer_array + "," +this.customer_name5
      }
      console.log(this.agreement.customer_array);
    },
    onWsError(evt) { 
    },
  
    doSend(message) {
      this.socket.send(message); 
    }, 
    wsOpen()
    {
      if(typeof(WebSocket) == "undefined"){
        return false;
      }

      let that = this
      this.socket = new WebSocket(this.wsUri); 
      this.socket.onopen = function(evt) { 
        that.onWsOpen(evt) 
      }; 
      this.socket.onclose = function(evt) { 
        that.onWsClose(evt) 
      }; 
      this.socket.onmessage = function(evt) { 
        that.onWsMessage(evt) 
      }; 
      this.socket.onerror = function(evt) { 
        that.onWsError(evt) 
      }; 

      return true;
    },
    
    wsClose()
    {
      this.socket.close(); 
    },

    onJsopReadCard(resultInfo, status) {
      console.info("readIDCard ", resultInfo, status);
      // $("#output").text(JSON.stringify(resultInfo));
      if( resultInfo.result === 0 ){

        var	result = this.parseCardInfo(resultInfo.wzInfo);
        
      }
      else {
        //alert(resultInfo.errorMsg);
      }

    },

    getInfo()
    {
      this.msgid = this.msgid+1;
      this.doSend("{\"module\":\"common\",\"msgid\":\"" + this.msgid+  "\",\"function\":\"info\"}"); 
    },

    readIdCard()
    {
      this.is_entrust = false;
        // console.log("点击乙方数据");
        // console.log(this.is_entrust);
      this.msgid = this.msgid+1;
      if(this.websocket_supported && this.socket.readyState == 1) {
        this.doSend("{\"module\":\"idcard\",\"msgid\":\"" + this.msgid+  "\",\"function\":\"readcard\"}"); 
      }
      else if(this.jsonp_supported) {
        
        readIDCard().then(response => {
          this.onJsopReadCard()
        });
      }
      else {
        console.log("未检测到阅读器插件!");
      }
    
	},
  readIdCardEntrust()
    {
      this.is_entrust = true;
        // console.log("点击委托人数据");
        // console.log(this.is_entrust);
      this.msgid = this.msgid+1;
      if(this.websocket_supported && this.socket.readyState == 1) {
        this.doSend("{\"module\":\"idcard\",\"msgid\":\"" + this.msgid+  "\",\"function\":\"readcard\"}"); 
      }
      else if(this.jsonp_supported) {
        
        readIDCard().then(response => {
          this.onJsopReadCard()
        });
      }
      else {
        console.log("未检测到阅读器插件!");
      }
    
	},
  }
};
</script>

<style scoped>
body {
  margin: auto;
  padding: auto;
  background: rgb(65, 63, 63);
  
}
.A4 {
  background: rgb(255, 253, 253);
  /* background-image: url(/../assets/hetong.png); */
  /* width: 21cm;
  height: 29.7cm; */
  /* width: 1122px;
  height: 794px; */
  display: block;
  /* box-shadow: 0 0 1px 1px rgb(2, 164, 252); */
  overflow-y: auto;
  box-sizing: border-box;
  margin: auto;
  font-family:serif;
  color: #000;
}

.head-1 {
  margin-top: 0;
  /* padding: 0 0 20px 0; */
  font-weight: 600;
  font-size: 16pt;
  text-align: center;
  width: 100%;
}

.head-2 {
  padding: 2pt;
  font-weight: 600;
  text-align: center;
}

.head-3 {
  font-weight: 400;
  font-size: 12pt !important;
  text-align: center;
}

.head-4 {
  font-weight: 400;
  font-size: 12pt !important;
  text-align: center;
  background-color: rgb(140, 160, 150);
}

.input-text {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(3, 54, 192);
}

.input-text-red {
  font-weight: 700;
  font-size: 10pt;
  color: rgb(231, 5, 5);
}

.money {
  text-align: left;
  font-weight: 600;
  color: rgb(3, 54, 192);
  padding: 0 0 0 20px;
}

td {
  padding-top: 9px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
}

table {
  margin: auto;
  text-align: right;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  justify-content: space-around;
}

.note-header {
  padding: 0px 30px 4px 40px;
  font-size: 9.5pt;
}
.indent{
  text-indent:2em
}

.line{
  line-height: 1.5;
}

.note-footer {
  padding: 20px 25px 10px 40px;
}

.my-input240 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 200px;
  text-align: center;
}

.my-input260 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 200px;
  text-align: center;
}
.my-input300 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 300px;
  text-align: center;
}
.my-input200 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 220px;
  text-align: center;
}
.my-input210 {
  width: 210px;
  text-align: left;
}
.my-input250{
  width: 300px;
  text-align: left;
}
.my-input380 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 380px;
  text-align: center;
}
.my-input405 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 405px;
  text-align: center;
}
.my-input430 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 430px;
  text-align: left;
}
.my-input150 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 150px;
  text-align: center;
}

.my-input120 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 120px;
  text-align: center;
}
.my-input100 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 100px;
  text-align: center;
}
.my-input65 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 65px;
  text-align: center;
}
.my-input35 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 35px;
  text-align: center;
}
.my-input55 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 55px;
  text-align: center;
}

.data-text {
  border-bottom: 1.5px solid #555555;
}

.my-input {
  margin: 0 35px 0 0;
}

.sanjiaoxing {
  width: 0;
  height: 0;
  border-color: transparent rgb(231, 93, 93);
  border-width: 0 0 120px 120px;
  border-style: solid;
  position: absolute;
}

.sequence {
  margin: 0 0 5px 10px;
  padding: 0 5px 0 5px;
  position: absolute;
  /* background-color: rgb(172, 104, 104); */
  transform: rotate(-45deg);
  transform-origin: 20% 40%;
}
.icon-check{
  color:#000 !important;
  margin-right: -5px;
  font-size: 12px !important;
  height: 0px;
  width: 25px;
}
.theme--dark .v-label{
  color: #000 !important;
}


@page {
  /* size: A4; */
  size: landscape;
  margin: 0;
}

/* @media print{@page {size: landscape}} */

@media print {
  .A4 {
    background: white;
  }

  .head-2 {
    background-color: rgb(231, 229, 226);
  }

  .head-4 {
    background-color: rgb(231, 229, 226);
  }

  .my-header {
    height: 50px;
  }
  .my-btn {
    display: none;
  }

  .six_word {
    width: 120px;
  }

  .sanjiaoxing {
    display: none;
  }

  .sequence {
    display: none;
  }
}
</style>
